<template>
  <router-link class="file-link file-link--b" to="/tasks"><i class="fas fa-arrow-left"></i> Все задачи</router-link>
  <PageHeading :title="task ? `Задача № ${task.id}` : 'Задача'" description="Описание, ход выполнения и обсуждение с командой." />
  <p v-if="error" class="error" role="alert">{{ error }}</p>
  <div v-if="createdNotice" class="task-created" role="status"><span class="task-created-icon"><i class="fa-solid fa-check" aria-hidden="true"></i></span><div><strong>Задача успешно добавлена!</strong><p>Задача № {{ $route.params.id }} создана и передана менеджеру. Здесь вы сможете следить за выполнением и оставлять комментарии.</p></div><button type="button" aria-label="Закрыть сообщение" @click="createdNotice = false"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button></div>
  <PageLoader v-if="loading && !task" label="Загружаем задачу и комментарии" />
  <div v-if="task" class="task-detail-grid">
    <section class="card task-card task-progress">
      <div class="task-info-head"><span><i class="fa-solid fa-chart-simple" aria-hidden="true"></i></span><div><h3>Ход выполнения</h3><p>Зелёные этапы пройдены, текущий выделен цветом</p></div></div>
      <ol class="task-steps"><li v-for="(step, index) in steps" :key="step.key" :class="[step.key, { reached: step.reached, current: step.key === state || (state === 'paused' && step.key === 'working'), paused: state === 'paused' && step.key === 'working' }]" :aria-current="step.key === state || (state === 'paused' && step.key === 'working') ? 'step' : undefined"><span class="task-step-dot">{{ step.reached && step.key !== state && !(state === 'paused' && step.key === 'working') ? '✓' : index + 1 }}</span><span>{{ state === 'paused' && step.key === 'working' ? 'Приостановлена' : step.label }}</span></li></ol>
    </section>
    <div>
      <section class="card task-card task-detail-main"><div class="task-detail-summary"><div class="task-heading"><span class="task-badge" :class="state">{{ taskStates[state] }}</span></div><span class="task-detail-number">ЗАДАЧА № {{ task.id }}</span><h2>{{ task.title }}</h2><p>Ниже — описание, которое получила команда.</p></div><div class="task-detail-description"><h3>Описание задачи</h3><TaskRichText :html="task.description_html" kind="task" :record-id="task.id" /><div v-if="task.files.length" class="task-detail-files"><h3>Приложенные файлы</h3><ul class="task-downloads"><li v-for="file in task.files" :key="file.id"><button class="file-link" :disabled="downloading" @click="fileDownload(file)"><i class="fa-solid fa-paperclip" aria-hidden="true"></i> {{ file.name }}</button></li></ul></div></div></section>

      <Teleport to="body" :disabled="!chatExpanded">
      <section id="comments" ref="discussion" class="card task-card task-discussion" :class="{ 'task-chat-expanded': chatExpanded }" :style="chatExpanded ? chatViewportStyle : undefined" :role="chatExpanded ? 'dialog' : undefined" :aria-modal="chatExpanded ? true : undefined" aria-label="Переписка по задаче" @keydown="chatKeydown">
        <div class="task-heading chat-heading"><h2><i class="fa-solid fa-comments" aria-hidden="true"></i> {{ chatExpanded ? `Задача № ${task.id}` : 'Переписка с командой' }} <small>({{ task.comments.length }})</small></h2><button ref="chatToggle" type="button" class="chat-expand-button" :aria-expanded="chatExpanded" :aria-label="chatExpanded ? 'Свернуть чат' : 'Развернуть чат на весь экран'" @click="toggleChat"><i :class="chatExpanded ? 'fa-solid fa-compress' : 'fa-solid fa-expand'" aria-hidden="true"></i><span>{{ chatExpanded ? 'Свернуть' : 'На весь экран' }}</span></button></div>
        <p class="task-section-caption">Ответы команды и ваши комментарии по этой задаче</p>
        <p v-if="soundError" class="error" role="status">{{ soundError }}</p>
        <p v-if="refreshError" class="error" role="status">{{ refreshError }}</p>
        <p v-if="readError" class="error" role="status">{{ readError }} <button class="file-link" :disabled="readSaving" @click="markTaskRead">Повторить</button></p>
        <p v-if="!task.comments.length" class="task-hint">Сообщений пока нет. Здесь появятся ваши комментарии и ответы команды.</p>
        <p v-if="chatExpanded && error" class="error chat-error" role="alert">{{ error }}</p>
        <div class="conversation-shell">
        <div ref="conversation" class="task-conversation" tabindex="0" aria-label="История сообщений" @scroll.passive="conversationScrolled" @load.capture="conversationContentLoaded" @wheel.passive="stopFollowingConversation" @touchmove.passive="stopFollowingConversation" @pointerdown="stopFollowingConversation" @keydown="conversationKeydown">
          <div ref="conversationMessages" class="conversation-messages">
          <article v-for="comment in task.comments" :key="comment.id" :data-comment-id="comment.id" class="task-message" :class="{ own: comment.own, targeted: String(comment.id) === $route.query.comment }">
            <div class="comment-avatar" aria-hidden="true">{{ comment.own ? 'К' : comment.author.slice(0, 1) }}</div>
            <div class="comment-content">
              <div class="task-message-header"><strong>{{ comment.own ? 'Вы' : comment.author }}</strong><time>{{ date(comment.date) }}</time></div>
              <TaskRichText :html="comment.html" kind="comment" :record-id="comment.id" />
              <button v-if="!comment.own && [0, 11].includes(Number(comment.type_comment))" type="button" class="file-link comment-reply" :disabled="saving" @click="reply(comment)"><i class="fa-solid fa-reply" aria-hidden="true"></i> Ответить</button>
              <ul class="task-downloads"><li v-for="file in comment.files" :key="file.id"><button class="file-link" :disabled="downloading" @click="fileDownload(file)"><i class="fa-solid fa-paperclip" aria-hidden="true"></i> {{ file.name }}</button></li></ul>
              <p v-if="comment.own" class="comment-read-status" :class="{ confirmed: comment.manager_read || comment.staff_read }"><i class="fa-solid" :class="comment.manager_read || comment.staff_read ? 'fa-check-double' : 'fa-check'" aria-hidden="true"></i> {{ comment.manager_read === undefined ? 'Статус прочтения недоступен' : comment.manager_read ? 'Прочитано менеджером' : comment.staff_read ? 'Прочитано сотрудником' : 'Ещё не прочитано' }}</p>
            </div>
          </article>
          <div ref="conversationEnd" class="conversation-end" aria-hidden="true"></div>
          </div>
        </div>
        <button v-if="newIncomingIds.length" type="button" class="conversation-jump" aria-live="polite" @click="jumpToLatest"><i class="fa-solid fa-arrow-down" aria-hidden="true"></i> Новых сообщений: {{ newIncomingIds.length }}</button>
        </div>
        <form class="task-form" @submit.prevent="send">
          <h3>Написать комментарий</h3>
          <TaskEditor ref="commentEditor" v-model="text" :disabled="saving" :chat-mode="chatExpanded" label="Комментарий к задаче" @attach="$refs.attachments.open()" @files="$refs.attachments.add($event)">
            <template #attachments><TaskAttachments ref="attachments" v-model="files" :disabled="saving" compact /></template>
          </TaskEditor>
        </form>
      </section>
      </Teleport>
    </div>
    <aside class="task-detail-sidebar">
      <section class="card task-card task-history" v-if="task.history && task.history.length > 1">
        <h2><i class="fas fa-history" aria-hidden="true"></i> История выполнения</h2>
        <p class="task-section-caption">Когда и как менялся ход работы</p>
        <ol class="task-history-list">
          <li v-for="(event, index) in task.history" :key="event.id" :class="{ latest: index === task.history.length - 1 }">
            <span class="task-history-marker" aria-hidden="true"><i :class="event.id === 'created' ? 'fas fa-plus' : 'fas fa-check'"></i></span>
            <div class="task-history-event"><time>{{ date(event.date) }}</time><strong>{{ event.label }}</strong></div>
          </li>
        </ol>
      </section>
      <section class="card task-card task-info"><h2 class="task-facts-heading">Сведения о задаче</h2><dl class="task-info-facts"><div><dt>Договор</dt><dd>№ {{ task.number }} · {{ task.contract }}<span v-if="task.domain" class="sub">{{ task.domain }}</span></dd></div><div><dt>Исполнители</dt><dd>{{ task.assignees.join(', ') || 'Назначаются' }}</dd></div><div><dt>Создана</dt><dd>{{ date(task.date) }}</dd></div><div><dt>Плановый срок</dt><dd>{{ date(task.deadline) }}</dd></div><div v-if="validDate(task.started)"><dt>Работа начата</dt><dd>{{ date(task.started) }}</dd></div><div v-if="validDate(task.stopped) && ['review', 'closed'].includes(state)"><dt>{{ state === 'closed' ? 'Завершена' : 'Передана на проверку' }}</dt><dd>{{ date(task.stopped) }}</dd></div></dl><div class="task-info-alert"><i class="fa-regular fa-envelope" aria-hidden="true"></i><div><strong>Уведомления по e-mail</strong><p v-if="task.notification_emails.length">{{ task.notification_emails.join(', ') }}</p><p v-else>Выключены для этой задачи</p></div></div></section>
    </aside>
  </div>
</template>
<script>
import PageHeading from '@/components/PageHeading.vue'
import TaskEditor from '@/components/TaskEditor.vue'
import TaskAttachments from '@/components/TaskAttachments.vue'
import TaskRichText from '@/components/TaskRichText.vue'
import { get, post, download } from '@/api'
import { date } from '@/utils/format'
import { taskStates, taskState, taskForm } from '@/utils/tasks'
export default {
  components: { PageHeading, TaskEditor, TaskAttachments, TaskRichText },
  data: () => ({ taskStates, task: null, text: '', files: [], loading: false, saving: false, downloading: false, error: '', refreshError: '', readError: '', readSaving: false, soundError: '', soundPending: false, seenIncoming: null, createdNotice: false, requestId: 0, chatExpanded: false, chatAtBottom: true, chatViewportStyle: {}, scrollToLatest: false, followingConversation: false, newIncomingIds: [] }),
  computed: {
    state() { return this.task ? taskState(this.task) : 'waiting' },
    steps() { const keys = ['waiting', 'working', 'review', 'closed']; const current = keys.indexOf(this.state === 'paused' ? 'working' : this.state); return keys.map((key, i) => ({ key, label: taskStates[key], reached: i <= current })) }
  },
  mounted() {
    this.createdNotice = this.consumeCreatedNotice(); this.load()
    this.prepareSound()
    document.addEventListener('click', this.unlockSound)
    document.addEventListener('keydown', this.unlockSound)
    this.timer = setInterval(() => { if (!this.loading && !this.saving) this.load(true) }, 5000)
    document.addEventListener('visibilitychange', this.scheduleRead)
    window.addEventListener('focus', this.scheduleRead)
    window.addEventListener('portal-open-comments', this.scrollToComments)
  },
  updated() { this.observeConversation() },
  beforeUnmount() {
    this.disconnectConversationObserver()
    this.closeChat()
    this.clearSentScroll()
    clearInterval(this.timer); clearTimeout(this.readTimer); this.requestId++; this.disposed = true
    document.removeEventListener('click', this.unlockSound)
    document.removeEventListener('keydown', this.unlockSound)
    if (this.audioEngine) this.audioEngine.close().catch(() => {})
    document.removeEventListener('visibilitychange', this.scheduleRead)
    window.removeEventListener('focus', this.scheduleRead)
    window.removeEventListener('portal-open-comments', this.scrollToComments)
  },
  watch: {
    '$route.params.id'() { this.disconnectConversationObserver(); this.closeChat(); this.clearSentScroll(); this.newIncomingIds = []; this.task = null; this.seenIncoming = null; this.soundPending = false; this.text = ''; this.files = []; this.readError = ''; this.createdNotice = this.consumeCreatedNotice(); this.load() },
    '$route.fullPath'() { if (this.task && String(this.task.id) === String(this.$route.params.id) && this.$route.hash === '#comments') this.scrollToComments() }
  },
  methods: {
    date,
    disconnectConversationObserver() {
      this.conversationResizeObserver?.disconnect()
      this.conversationResizeObserver = null
      this.observedConversation = null; this.observedMessages = null
    },
    observeConversation() {
      const box = this.$refs.conversation, messages = this.$refs.conversationMessages
      if (box === this.observedConversation && messages === this.observedMessages) return
      this.disconnectConversationObserver()
      if (!box || !messages || !window.ResizeObserver || this.disposed) return
      this.observedConversation = box; this.observedMessages = messages
      this.conversationResizeObserver = new window.ResizeObserver(() => {
        if (!this.disposed && this.followingConversation && box === this.$refs.conversation) this.pinConversationBottom()
      })
      // The inner wrapper grows after image/font loading; the viewport can also resize.
      this.conversationResizeObserver.observe(messages)
      this.conversationResizeObserver.observe(box)
    },
    stopFollowingConversation() { this.followingConversation = false; this.scrollToLatest = false },
    conversationKeydown(event) {
      if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) this.stopFollowingConversation()
    },
    pinConversationBottom() {
      const box = this.$refs.conversation
      if (!box) return
      box.scrollTo({ top: box.scrollHeight, behavior: 'auto' })
      box.scrollTop = box.scrollHeight
      this.chatAtBottom = true
      this.newIncomingIds = []
    },
    conversationScrolled() {
      const box = this.$refs.conversation
      if (!box) return
      const gap = box.scrollHeight - box.scrollTop - box.clientHeight
      this.chatAtBottom = gap <= 150
      if (gap <= 2) { this.newIncomingIds = []; this.followingConversation = true }
    },
    jumpToLatest() {
      this.followingConversation = true
      this.$refs.conversation?.focus({ preventScroll: true })
      this.pinConversationBottom()
    },
    conversationContentLoaded() {
      if (this.followingConversation || this.chatAtBottom) this.pinConversationBottom()
    },
    async syncChatViewport() {
      if (!this.chatExpanded) return
      const follow = this.chatAtBottom
      const viewport = window.visualViewport
      this.chatViewportStyle = { '--chat-height': `${viewport?.height || window.innerHeight}px`, '--chat-top': `${viewport?.offsetTop || 0}px` }
      await this.$nextTick()
      if (this.chatExpanded && follow) this.pinConversationBottom()
    },
    async toggleChat() {
      if (this.chatExpanded) {
        this.closeChat()
        await this.$nextTick()
        this.$refs.chatToggle?.focus({ preventScroll: true })
        return
      }
      this.clearSentScroll()
      this.chatExpanded = true; this.chatAtBottom = true; this.followingConversation = true
      const body = document.body, root = document.documentElement
      const bodyOverflow = body.style.overflow, rootOverflow = root.style.overflow
      body.style.overflow = 'hidden'; root.style.overflow = 'hidden'
      const viewport = window.visualViewport
      const update = () => this.syncChatViewport()
      window.addEventListener('resize', update)
      viewport?.addEventListener('resize', update)
      viewport?.addEventListener('scroll', update)
      this.chatCleanup = () => {
        body.style.overflow = bodyOverflow; root.style.overflow = rootOverflow
        window.removeEventListener('resize', update)
        viewport?.removeEventListener('resize', update)
        viewport?.removeEventListener('scroll', update)
      }
      await this.syncChatViewport()
      this.pinConversationBottom()
      this.$refs.chatToggle?.focus({ preventScroll: true })
    },
    closeChat() {
      this.clearSentScroll()
      if (this.chatExpanded) this.$refs.commentEditor?.$refs?.input?.blur()
      this.chatCleanup?.(); this.chatCleanup = null
      this.chatExpanded = false; this.chatViewportStyle = {}
    },
    chatKeydown(event) {
      if (!this.chatExpanded) return
      if (event.key === 'Escape') { event.preventDefault(); this.toggleChat(); return }
      if (event.key !== 'Tab') return
      const controls = Array.from(this.$refs.discussion.querySelectorAll('button:not(:disabled), textarea:not(:disabled), a[href]')).filter(element => element.getClientRects().length)
      const first = controls[0], last = controls[controls.length - 1]
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus() }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus() }
    },
    clearSentScroll() { this.scrollToLatest = false; this.followingConversation = false },
    revealSentMessage(request) {
      if (this.disposed || request !== this.requestId) return
      this.pinConversationBottom()
    },
    async scrollToComments() {
      this.clearSentScroll()
      await this.$nextTick()
      const box = this.$refs.conversation
      if (!box || this.disposed) return
      const id = String(this.$route.query?.comment || '')
      const target = Array.from(box.querySelectorAll('.task-message')).find(element => element.dataset.commentId === id)
      box.scrollTo({ top: target ? box.scrollTop + target.getBoundingClientRect().top - box.getBoundingClientRect().top - 20 : box.scrollHeight, behavior: 'auto' })
      const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches
      if (!this.chatExpanded) this.$refs.discussion?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' })
      this.scheduleRead()
    },
    consumeCreatedNotice() { try { const key = 'portal-created-task'; const id = sessionStorage.getItem(key); if (id === String(this.$route.params.id)) { sessionStorage.removeItem(key); return true } } catch (_) { /* Storage may be unavailable. */ } return false },
    validDate(value) { return value && !value.startsWith('0000-') },
    prepareSound() {
      if (this.audioEngine || this.disposed) return
      try {
        const AudioEngine = window.AudioContext || window.webkitAudioContext
        if (!AudioEngine) throw new Error('Звук не поддерживается этим браузером.')
        this.audioEngine = new AudioEngine()
      } catch (_) { this.soundError = 'Браузер не поддерживает звук уведомлений.' }
    },
    async unlockSound() {
      this.prepareSound()
      if (!this.audioEngine || this.disposed || this.audioEngine.state === 'running') return
      try {
        await this.audioEngine.resume()
        if (this.disposed) return
        this.soundError = ''
        if (this.soundPending) { this.soundPending = false; await this.playMessageSound() }
      } catch (_) { if (!this.disposed) this.soundError = 'Браузер заблокировал звук уведомлений. Проверьте настройки звука для сайта.' }
    },
    async playMessageSound() {
      const engine = this.audioEngine
      if (!engine || this.disposed) return
      if (engine.state !== 'running') { this.soundPending = true; return }
      this.soundPending = false
      const start = engine.currentTime
      for (const [offset, frequency] of [[0, 660], [0.16, 880]]) {
        const tone = engine.createOscillator(), volume = engine.createGain()
        tone.type = 'sine'; tone.frequency.value = frequency
        volume.gain.setValueAtTime(0, start + offset)
        volume.gain.linearRampToValueAtTime(0.08, start + offset + 0.02)
        volume.gain.exponentialRampToValueAtTime(0.001, start + offset + 0.22)
        tone.connect(volume); volume.connect(engine.destination)
        tone.onended = () => { tone.disconnect(); volume.disconnect() }
        tone.start(start + offset); tone.stop(start + offset + 0.24)
      }
    },
    notifyIncoming(comments) {
      const incoming = comments.filter(comment => !comment.own && [0, 11].includes(Number(comment.type_comment))).map(comment => String(comment.id))
      if (this.seenIncoming === null) { this.seenIncoming = new Set(incoming); return }
      const hasNew = comments.some(comment => !comment.read && !comment.own && [0, 11].includes(Number(comment.type_comment)) && !this.seenIncoming.has(String(comment.id)))
      incoming.forEach(id => this.seenIncoming.add(id))
      if (hasNew) this.playMessageSound().catch(() => { if (!this.disposed) this.soundError = 'Не удалось воспроизвести звук уведомления. Проверьте настройки звука для сайта.' })
    },
    reply(comment) {
      if (this.saving || comment.own || ![0, 11].includes(Number(comment.type_comment))) return
      if (!this.$refs.commentEditor.insertQuote(comment.author, comment.text)) this.error = 'Цитата вместе с вашим текстом превышает лимит 20 000 символов.'
      else this.error = ''
    },
    scheduleRead() { clearTimeout(this.readTimer); if (!this.disposed) this.readTimer = setTimeout(() => this.markTaskRead(), 0) },
    async markTaskRead() {
      if (this.disposed || this.readSaving || !this.task || document.hidden) return
      if (!this.task.comment_reads_supported) { this.readError = 'API кабинета не поддерживает отметки прочтения. Обновите API и прокси.'; return }
      const ids = this.task.comments.filter(comment => !comment.read).map(comment => Number(comment.id))
      if (!ids.length) return
      const taskId = this.task.id
      this.readSaving = true
      try {
        const result = await post('read-task-comments', { id: taskId, comment_ids: ids.slice(0, 100), all: true, through_comment_id: ids.reduce((latest, id) => Math.max(latest, id), 0) }, this.$store.state.csrf)
        if (!result.ok || !Array.isArray(result.comment_ids)) throw new Error('API не подтвердил сохранение отметок. Обновите API и прокси.')
        const confirmed = new Set(result.comment_ids)
        if (ids.some(id => !confirmed.has(id))) throw new Error('API не подтвердил сохранение отметок. Обновите API и прокси.')
        if (!this.disposed && this.task?.id === taskId) {
          this.readError = ''
          for (const comment of this.task.comments) if (confirmed.has(Number(comment.id))) comment.read = true
          window.dispatchEvent?.(new Event('portal-comments-read'))
          this.scheduleRead()
        }
      } catch (error) { if (!this.disposed && this.task?.id === taskId) this.readError = `Не удалось сохранить отметку прочтения: ${error.message}` }
      finally { this.readSaving = false }
    },
    async load(silent = false, scrollToBottom = false) {
      const request = ++this.requestId
      this.loading = true; if (!silent) this.error = ''
      try {
        const task = await get('task', { id: this.$route.params.id })
        if (request === this.requestId) {
          const firstLoad = !this.task
          const previousLast = this.task?.comments?.slice(-1)[0]?.id
          const box = this.$refs.conversation
          // Use the position when the response arrives, after any scrolling during the request.
          const atBottom = !box || box.scrollHeight - box.scrollTop - box.clientHeight <= 150
          const previousTop = box?.scrollTop || 0
          const previousIds = new Set((this.task?.comments || []).map(comment => String(comment.id)))
          const incoming = task.comments.filter(comment => !comment.own && [0, 11].includes(Number(comment.type_comment)))
          const visibleIds = new Set(incoming.map(comment => String(comment.id)))
          this.newIncomingIds = this.newIncomingIds.filter(id => visibleIds.has(id))
          if (!firstLoad && !atBottom && !scrollToBottom && !this.scrollToLatest) {
            const newIds = incoming.filter(comment => !previousIds.has(String(comment.id))).map(comment => String(comment.id))
            this.newIncomingIds = [...new Set([...this.newIncomingIds, ...newIds])]
            this.followingConversation = false
          }
          this.notifyIncoming(task.comments)
          this.task = task; this.refreshError = ''
          await this.$nextTick()
          if (scrollToBottom || this.scrollToLatest) {
            this.pinConversationBottom()
            this.scrollToLatest = false
          } else if (firstLoad && this.$route.hash === '#comments') {
            await this.scrollToComments()
          } else if (atBottom && this.$refs.conversation && (firstLoad || scrollToBottom || previousLast !== task.comments.slice(-1)[0]?.id)) {
            this.followingConversation = true
            this.pinConversationBottom()
          } else if (!atBottom && this.$refs.conversation) {
            this.$refs.conversation.scrollTop = previousTop
          }
          this.scheduleRead()
        }
      }
      catch (error) { if (request === this.requestId) { if (silent) this.refreshError = 'Не удалось обновить задачу. Повторим автоматически.'; else this.error = error.message } }
      finally { if (request === this.requestId) this.loading = false }
    },
    async send() {
      if (this.saving) return
      if (!this.text || this.text.length > 20000) { this.error = 'Введите сообщение до 20 000 символов разметки.'; return }
      this.saving = true; this.error = ''
      const taskId = String(this.task.id)
      try {
        await post('add-task-comment', taskForm({ id: this.task.id, text: this.text }, this.files), this.$store.state.csrf)
        if (this.disposed || String(this.task?.id) !== taskId) return
        this.scrollToLatest = true; this.followingConversation = true
        if (!this.chatExpanded) this.$refs.commentEditor?.$refs?.input?.blur()
        this.text = ''; this.files = []
        await this.load(false, true)
        await this.$nextTick()
        if (!this.disposed && String(this.task?.id) === taskId) this.pinConversationBottom()
      }
      catch (error) { this.error = error.message }
      finally { this.saving = false }
    },
    async fileDownload(file) { this.downloading = true; this.error = ''; try { await download('task-file', file.id, 0) } catch (error) { this.error = error.message } finally { this.downloading = false } }
  }
}
</script>
<style scoped>
.task-detail-grid .task-card { border-width: 1px; border-style: solid; }
.task-detail-grid .task-detail-main { border-color: #cbd9eb; background: #fff;    background: #f7f6f6; }
.task-detail-grid .task-history { border-color: #dce3ec; background: #fff; }
.task-detail-grid .task-discussion { border-color: #d1e3de; border: 1px solid #519789; background: #fff; }
.task-detail-grid .task-info { border-color: #dce3ec; background: #fff; }
.task-detail-grid .task-progress { grid-column: 1 / -1; margin-bottom: 0; border-color: #d4deed; background: #fff; }
.task-detail-grid > div, .task-detail-sidebar { min-width: 0; }
.task-section-caption { margin: 6px 0 20px; font-size: 13px; line-height: 1.5; }
.task-history .task-section-caption { color: #7c8da4; }
.task-discussion .task-section-caption { color: #47796e; }
.task-history h2 { display: flex; align-items: center; gap: 10px; margin-bottom: 0; color: #344a68; font-size: 17px; }
.task-history h2 i { color: #70849e; }
.task-history-list { margin: 22px 0 0; padding: 0; list-style: none; }
.task-history-list li { position: relative; display: flex; gap: 14px; padding-bottom: 18px; }
.task-history-list li::before { content: ''; position: absolute; top: 28px; bottom: 0; left: 14px; width: 2px; background: #e1e7ef; }
.task-history-list li:last-child { padding-bottom: 0; }
.task-history-list li:last-child::before { display: none; }
.task-history-marker { position: relative; display: grid; place-items: center; flex: 0 0 30px; height: 30px; border-radius: 50%; color: #70849e; background: #edf1f6; font-size: 11px; }
.task-history-event { flex: 1; min-width: 0; padding: 11px 14px; border: 1px solid #e3e9f0; border-radius: 10px; background: #f8fafc; }
.task-history-event time { display: block; margin-bottom: 5px; color: #7c8da4; font-size: 12px; }
.task-history-event strong { display: block; color: #344a68; font-size: 14px; line-height: 1.5; overflow-wrap: anywhere; }
.task-history-list .latest .task-history-marker { color: #fff; background: #5a80b1; }
.task-history-list .latest .task-history-event { border-color: #c9d9ee; background: #f0f5fc; }
.task-detail-grid { display: grid; grid-template-columns: minmax(0, 1fr) 300px; gap: 24px; align-items: start; }
.task-created { display: flex; align-items: flex-start; gap: 16px; margin: 8px 0 23px; padding: 21px 22px; border: 1px solid #adddc4; border-radius: 15px; color: #1f684b; background: #e9f8ef; box-shadow: 0 8px 22px #277c4c12; }
.task-created-icon { display: grid; place-items: center; flex: 0 0 42px; height: 42px; border-radius: 50%; color: white; background: #2eaa70; font-size: 18px; }
.task-created strong { display: block; margin: 2px 0 5px; font-size: 18px; }
.task-created p { margin: 0; line-height: 1.55; font-size: 14px; }
.task-created button { margin-left: auto; padding: 6px; border: 0; color: #48916b; background: transparent; cursor: pointer; }
.task-detail-main { overflow: hidden; }
.task-detail-summary { padding: 19px 22px 21px; border-radius: 10px; color: #000; border:1px #2757a7 dashed; box-sizing:border-box; background:#fff; }
.task-detail-summary .task-heading { margin-bottom: 21px; }
.task-detail-summary .quiet { border-color: #ffffff8c; color: white; background: #ffffff1a; }
.task-detail-summary .quiet:hover { background: #ffffff36; }
.task-detail-auto-update { color: #deebff; font-size: 12px; }
.task-detail-auto-update i { margin-right: 5px; }
.task-detail-number { color: #000; font-size: 10px; font-weight: 800; letter-spacing: .12em; }
.task-detail-summary h2 { margin: 6px 0 7px; font-size: 30px; overflow-wrap: anywhere; }
.task-detail-summary p { margin: 0; color: #000; font-size: 13px; }
.task-detail-description { margin-top: 18px; padding: 20px; border: 1px solid #d6e4f7; border-radius: 11px; background: #fff; 
background: #fff9e6;
    border: 1px solid #ffd966;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 25px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, .05);
    color:#000;

}
.task-detail-description h3 { 
display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ffd966;
      font-size: 18px;
    font-weight: 700;
    color: #b38700;

}
.task-detail-files { margin-top: 24px; padding-top: 20px; border-top: 1px solid #e8edf4; }
.task-detail-files .task-downloads { display: flex; flex-wrap: wrap; gap: 8px; margin: 0; }
.task-detail-files .file-link { padding: 8px 11px; border-radius: 8px; background: #edf4fc; }
.task-info { position: static; }
.task-facts-heading { margin: 0 0 16px; color: #344a68; font-size: 17px; }
.task-info-head { display: flex; align-items: center; gap: 11px; margin-bottom: 18px; }
.task-info-head > span { display: grid; place-items: center; flex: 0 0 38px; height: 38px; border-radius: 11px; color: #3068bf; background: #e9f1ff; }
.task-info-head h3 { margin: 0 0 3px; color: #344a68; font-size: 16px; }
.task-info-head p { margin: 0; color: #7c8da4; font-size: 11px; }
.task-steps { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 10px; padding: 0; margin: 0; list-style: none; }
.task-steps li { display: flex; align-items: center; gap: 10px; padding: 12px; border: 1px solid #e1e6ed; border-radius: 10px; color: #778598; background: #f4f6f9; font-size: 13px; }
.task-steps .reached { border-color: #b8ddc8; color: #26744f; background: #e5f5eb; }
.task-steps .current { border-width: 2px; font-weight: 800; box-shadow: 0 3px 10px #233c6114; }
.task-steps .current.waiting { border-color: #dba740; color: #8d5d09; background: #fff0c8; }
.task-steps .current.working { border-color: #4787d4; color: #20599b; background: #dcecff; }
.task-steps .current.review { border-color: #9c72c7; color: #71449e; background: #eee0ff; }
.task-steps .current.closed { border-color: #36a16c; color: #186d43; background: #cff0dc; }
.task-steps .current.paused { border-color: #dba740; color: #8d5d09; background: #fff0c8; }
.task-step-dot { display: grid; place-items: center; flex: 0 0 25px; height: 25px; border-radius: 50%; color: #8a98aa; background: #e4e9f0; font-size: 11px; font-weight: 800; }
.task-steps .reached .task-step-dot { color: white; background: #439c6d; }
.task-steps .current.waiting .task-step-dot, .task-steps .current.paused .task-step-dot { color: white; background: #bc841f; }
.task-steps .current.working .task-step-dot { color: white; background: #3479c9; }
.task-steps .current.review .task-step-dot { color: white; background: #8a5ab8; }
.task-steps .current.closed .task-step-dot { color: white; background: #268953; }
.task-steps .current.paused .task-step-dot { background: #bc841f; }
.task-info-facts { display: grid; gap: 10px; margin: 0; padding-top: 18px; border-top: 1px solid #e8edf4; }
.task-info-facts > div { padding: 10px 12px; border: 1px solid #e6ebf2; border-radius: 9px; background: #f8fafc; }
.task-info-facts dt { margin: 0; color: #8392a7; font-size: 11px; }
.task-info-facts dd { margin: 4px 0 0; color: #344a68; line-height: 1.45; font-size: 12px; font-weight: 650; }
.task-info-alert { display: flex; gap: 10px; margin-top: 18px; padding: 13px; border-radius: 10px; color: #287459; background: #eaf8f0; }
.task-info-alert > i { margin-top: 2px; font-size: 16px; }
.task-info-alert strong { font-size: 12px; }
.task-info-alert p { margin: 4px 0 0; font-size: 11px; line-height: 1.5; overflow-wrap: anywhere; }
.task-discussion .task-heading { margin-bottom: 0; }
.task-discussion { scroll-margin-top: 24px; }
.chat-heading { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.chat-expand-button { display: none; align-items: center; justify-content: center; gap: 7px; flex-shrink: 0; min-height: 36px; padding: 7px 10px; border: 1px solid #c6ded5; border-radius: 9px; background: #f0f8f4; color: #216d5e; font-size: 12px; cursor: pointer; }
.conversation-messages { display: flow-root; min-width: 0; }
.conversation-shell { position: relative; min-width: 0; margin-bottom: 20px; }
.conversation-jump { position: absolute; z-index: 2; bottom: 12px; left: 50%; transform: translateX(-50%); display: inline-flex; align-items: center; justify-content: center; gap: 8px; max-width: calc(100% - 24px); min-height: 40px; padding: 9px 16px; border: 1px solid #a6d3c5; border-radius: 22px; background: #fff; color: #216d5e; box-shadow: 0 3px 12px #183f332b; font: inherit; font-size: 13px; font-weight: 600; white-space: nowrap; cursor: pointer; }
.conversation-jump:hover { background: #edf8f2; }
.conversation-jump:focus-visible { outline: 2px solid #32917b; outline-offset: 2px; }
.conversation-end { height: 1px; flex-shrink: 0; overflow-anchor: none; }
.task-conversation { overflow-anchor: none; scroll-behavior: auto; }
.task-chat-expanded { position: fixed; z-index: 1200; top: var(--chat-top, 0px); left: 0; right: 0; display: flex; flex-direction: column; box-sizing: border-box; height: 100vh; height: var(--chat-height, 100dvh); min-height: 0; margin: 0; padding: env(safe-area-inset-top, 0px) 0 0; border: 0; border-radius: 0; background: #fff; overflow: hidden; }
.task-chat-expanded .chat-heading { flex-shrink: 0; margin: 0; padding: 12px max(12px, env(safe-area-inset-right, 0px)) 12px max(12px, env(safe-area-inset-left, 0px)); border-bottom: 1px solid #d9e8e2; background: #f4faf7; }
.task-chat-expanded .chat-heading h2 { min-width: 0; font-size: 16px; }
.task-chat-expanded .chat-expand-button { display: inline-flex; }
.task-chat-expanded .task-section-caption { display: none; }
.task-chat-expanded > .error, .task-chat-expanded > .task-hint { flex-shrink: 0; margin: 0; padding: 8px 12px; font-size: 13px; }
.task-chat-expanded .conversation-shell { display: flex; flex-direction: column; flex: 1 1 0; min-height: 0; margin: 0; }
.task-chat-expanded .task-conversation { flex: 1 1 0; min-height: 0; max-height: none; margin: 0; border: 0; border-radius: 0; padding: 12px; overscroll-behavior-y: contain; -webkit-overflow-scrolling: touch; }
.task-discussion.task-chat-expanded .task-form { flex-shrink: 0; box-sizing: border-box; margin: 0; padding: 8px max(8px, env(safe-area-inset-right, 0px)) max(8px, env(safe-area-inset-bottom, 0px)) max(8px, env(safe-area-inset-left, 0px)); border: 0; border-top: 1px solid #d9e8e2; border-radius: 0; background: #fff; }
.task-chat-expanded .task-form h3 { display: none; }
@media (max-width: 800px) { .chat-expand-button { display: inline-flex; } }
.task-message.targeted .comment-content { outline: 2px solid #e0ad40; outline-offset: 3px; }
.task-discussion .task-heading h2 { margin: 0; color: #216d5e; font-size: 18px; }
.task-discussion .task-heading h2 > i { margin-right: 6px; color: #299b85; }
.task-discussion .task-heading h2 small { color: #47796e; font-size: 13px; }
.task-discussion .task-form { padding: 18px; border: 1px solid #c6e0d9; border-radius: 11px; background: #fff; }
.task-discussion .task-form h3 { margin: 0 0 14px; color: #216d5e; font-size: 15px; }
.task-conversation { max-height: 500px; overflow-y: auto; padding: 18px 14px; background: #f3f6f8; border: 1px solid #dbe4e9; border-radius: 10px; margin-bottom: 0; }
.task-message { display: flex; max-width: 90%; margin-bottom: 20px; align-items: flex-start; gap: 10px; }
.task-message.own { margin-left: auto; flex-direction: row-reverse; }
.comment-avatar { width: 40px; height: 40px; flex-shrink: 0; border-radius: 50%; display: grid; place-items: center; color: white; background: #2a56b6; font-weight: bold; }
.own .comment-avatar { background: #00a65a; }
.comment-content { min-width: 0; padding: 12px 16px; border: 1px solid #c9dbf2; border-radius: 18px; background: #f3f7ff; box-shadow: 0 1px 2px #0000001a; }
.own .comment-content { border-color: #b5dbc2; background: #def4e5; }
.task-message-header { display: flex; gap: 12px; justify-content: space-between; flex-wrap: wrap; margin-bottom: 14px; font-size: 13px; }
.task-message-header time { color: #748298; }
.comment-read-status { margin: 10px 0 0; color: #697b8c; font-size: 12px; }
.comment-read-status.confirmed { color: #18744d; }
.comment-read-status i { margin-right: 4px; }
.comment-reply { margin-top: 8px; font-size: 12px; }
.task-message-header strong { color: #2a56b6; }
.own .task-message-header strong { color: #128c7e; }
.task-downloads { padding: 0; list-style: none; display: grid; gap: 10px; overflow-wrap: anywhere; }
@media (max-width: 1000px) { .task-detail-grid { grid-template-columns: 1fr; } }
@media (max-width: 600px) { .task-steps { grid-template-columns: repeat(2, minmax(0, 1fr)); } .task-steps li { padding: 10px 8px; gap: 7px; } }
@media (max-width: 600px) { .task-detail-description, .task-discussion .task-form { padding: 14px; } .task-conversation { padding: 14px 8px; } .task-message { max-width: 100%; gap: 7px; } .comment-avatar { width: 32px; height: 32px; } .comment-content { padding: 11px 12px; } }

@media(max-width:768px) {
  .task-steps
  {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 5px;
  }
  .task-detail-grid
  {
    gap: 5px;
  }
  .comment-avatar
  {
    display: none;
  }
  .task-message
  {
    margin-bottom: 10px;
  }
  .task-conversation
  {
    box-sizing:border-box;
    padding: 10px;
  }
}

</style>
